module.exports = __webpack_public_path__ + "static/media/fraissard.78867de4.png";